import { $t } from "@/plugins/i18n";
import { tableView } from "@/router/enums";

const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/wb-student-classrooms",
    component: Layout,
    redirect: "/wb-student/my-classrooms",
    meta: {
      icon: "ic/outline-calendar-month",
      title: $t("wb.menu.myClasses"),
      rank: tableView + 5
    },
    children: [
      {
        path: "/wb-student/my-classrooms",
        name: "WbStudentMyClassrooms",
        component: () => import("@/views/wb-student/my-classrooms/index.vue"),
        meta: {
          title: $t("wb.menu.myClasses"),
          icon: "ic/outline-calendar-month",
          keepAlive: true,
          roles: ["student"]
        }
      }
    ]
  },
  {
    path: "/wb-student-credit",
    component: Layout,
    redirect: "/wb-student/credit-log",
    meta: {
      icon: "ic/outline-account-balance-wallet",
      title: $t("wb.menu.creditLog"),
      rank: tableView + 6
    },
    children: [
      {
        path: "/wb-student/credit-log",
        name: "WbStudentCreditLog",
        component: () => import("@/views/wb-student/credit-log/index.vue"),
        meta: {
          title: $t("wb.menu.creditLog"),
          icon: "ic/outline-account-balance-wallet",
          keepAlive: true,
          roles: ["student"]
        }
      }
    ]
  },
  {
    path: "/wb-student-hidden",
    component: Layout,
    meta: {
      title: $t("menus.pureEmpty"),
      showLink: false
    },
    children: [
      {
        path: "/wb-student/classroom-detail",
        name: "WbStudentClassroomDetail",
        component: () =>
          import("@/views/wb-student/classroom-detail/index.vue"),
        meta: {
          title: $t("wb.menu.classroomDetail"),
          showLink: false,
          keepAlive: false,
          roles: ["student"]
        }
      }
    ]
  }
] satisfies Array<RouteConfigsTable>;
